import { Reactivation as ReactivationComponent } from '@ltvco/refresh-lib';

export function Reactivation() {
  return (
    <div>
      <ReactivationComponent />
    </div>
  );
}
